import { branchTermPlural } from 'utils/terminology';

const formTitles = [
  { label: 'Mr', value: 'Mr' },
  { label: 'Mrs', value: 'Mrs' },
  { label: 'Miss', value: 'Miss' },
  { label: 'Ms', value: 'Ms' },
  { label: 'Dr', value: 'Dr' },
];

const metaInfo = {
  '/mycef/account/new': {
    title: 'Register for an Account | CEF',
    description:
      'Choose to activate your account or create a new account on CEF.',
  },
  '/mycef/account/new/step1': {
    title: 'Choose Your Company Type | CEF Account Registration',
    description:
      'Select your company type to proceed with CEF account registration. Set up your business account quickly and easily online. ',
  },
  '/mycef/account/new/step2': {
    title: 'Enter Company Details | CEF Account Setup',
    description:
      'Complete your company details to continue your CEF account registration. Ensure accuracy for a smooth sign-up process.',
  },
  '/mycef/account/new/step3': {
    title: 'Add Your Address | CEF Account Registration',
    description:
      'Provide your business address to finalise your CEF account registration. Complete this step to move forward. ',
  },
  '/mycef/account/new/step4': {
    title: 'Enter Contact Details | CEF Account Setup',
    description:
      'Fill in your contact details to complete your CEF account registration. Ensure correct details for seamless communication. ',
  },
  '/mycef/account/new/summary': {
    title: 'Review Your Details | CEF Account Registration',
    description:
      'Check and confirm your registration details before creating your CEF account. Ensure accuracy before finalising the process. ',
  },
  '/mycef/account/new/identity-verification': {
    title: 'Verify Your Identity | CEF Sole Trader Registration',
    description:
      'Answer identity verification questions to complete your CEF Sole Trader account setup. A quick step to secure your registration. ',
  },
  '/mycef/account/new/identity-verificaction-unsuccessful': {
    title: 'Verification Failed | CEF Sole Trader Registration',
    description:
      'Your identity verification was unsuccessful. Please check your details and try again or contact support for assistance. ',
  },
  '/mycef/account/new/registration-success': {
    title: 'Registration Successful | CEF Account Created',
    description:
      'Your CEF account has been successfully registered. Log in now to access exclusive trade features and services. ',
  },
  '/mycef/activations': {
    title: 'Activate Your CEF Account | Login to Get Started',
    description:
      'Enter your username and password to activate your CEF account. Complete activation now to start managing your orders.',
  },
  default: {
    title: 'Electrical Wholesalers | Cables | EV & Solar | Power Tools | CEF',
    description: `Choose from over 40,000 products from one of the UK's biggest electrical wholesaler. Free delivery over £50 and click & collect from one of our 400+ ${branchTermPlural}`,
  },
};

export { formTitles, metaInfo };
